import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { Context, getAccessToken } from '@/services/get-access-token'

export const GET_ACCESS_TOKEN = 'access-token'

export const useGetAccessToken = (
  context: Context,
  contextId: number,
  userId: number,
) => {
  const cacheTime = useMemo(() => (contextId ? Infinity : 0), [contextId])

  const query = useQuery({
    queryKey: [GET_ACCESS_TOKEN, { context, contextId, userId }],
    queryFn: ({ signal }) => getAccessToken(context, contextId, { signal }),
    enabled: !!contextId && !!userId,
    cacheTime,
  })

  return query
}
